import { ReactElement } from 'react';
import RenewNonEmployeeAccess from './RenewNonEmployeeAccess/RenewNonEmployeeAccess';
import withQueryCheck from 'pages/AnnualUserAccessReview/components/withQueryCheck';

/**
 * Form to submit when manager wishes to review, validate, and renew non-employee access
 * @returns {ReactElement} User Access Review Non-Employee Review Form
 */
const RenewForm = props => {
	return (
		<>
			<RenewNonEmployeeAccess {...props} />
		</>
	);
};

export default withQueryCheck(RenewForm);
